module.exports = __webpack_public_path__ + "img/NOAH.dc28121c.svg";